import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import moment from 'moment';

const defaultUserPic = toAbsoluteUrl("/media/atzmai/PEO-smiley_smile.svg");
const defaultUser = {
  personalInfo: {},
  bankInfo: {},
  practiceData: {},
  completedSteps: {},
  files: [],
  kids: [],
};

export const mapUserDetails = userDetails => {
  if (userDetails === null) {
    return defaultUser;
  }

  const {
    profile,
    file_list,
    additional_data,
    completedSteps,
    kidsDetails,
    ...restDetails
  } = userDetails;
  const user = {...defaultUser};

  if (file_list) {
    user.files = file_list;
  }

  if (completedSteps) {
    user.completedSteps = completedSteps;
  }

  if (kidsDetails) {
    user.kids = kidsDetails.map(transformKidsValues);
  }

  user.personalInfo = {
    pic: defaultUserPic,
    ...restDetails,
  };

  if (profile) {
    user.personalInfo = {
      ...user.personalInfo,
      ...profile,
    };
  }

  if (additional_data.length > 0) {
    const {
      address,
      personalDetails,
      bankInfo,
      practiceData,
      form101IncomeData,
      form6101IncomeData,
      createdAt,
      ...restAdditionalData
    } = additional_data[0];
    user.personalInfo = {
      ...user.personalInfo,
      ...restAdditionalData,
      ...personalDetails,
    };
    if (address) {
      user.personalInfo = {
        ...user.personalInfo,
        ...address
      }
    }
    if (form101IncomeData) {
      const {
        otherIncomeExists,
      } = form101IncomeData;
      user.personalInfo = {
        ...user.personalInfo,
        otherIncomeExists,
      }
    }
    if (form6101IncomeData) {
      const {
        freelanceStartDate,
        monthlyAverageIncome,
        weeklyAverageWorkHours,
        weeklyAverageWorkHoursText
      } = form6101IncomeData;
      user.personalInfo = {
        ...user.personalInfo,
        freelanceStartDate,
        monthlyAverageIncome,
        weeklyAverageWorkHours,
        weeklyAverageWorkHoursText
      }
    }

    user.bankInfo = bankInfo;

    user.practiceData = {
      ...practiceData,
      areaText: practiceData?.areaText ? joinToString(practiceData.areaText) : '',
      clientsText: practiceData?.clientsText ? joinToString(practiceData.clientsText) : '',
    };
  }

  return user;
};

const joinToString = arrayOfStrings => arrayOfStrings.join(", ");

const transformKidsValues = kid => {
  const {birthDate: unformattedDate, ...rest} = kid;
  const birthDate = moment(unformattedDate).format('DD/MM/YYYY');

  return {
    birthDate,
    ...rest
  }
};
